import React from "react";
import { motion } from "framer-motion";

const QUOTES = [
  {
    q:
      "The pods arrived greener than anything at the auction. You can smell the estate the moment you cut the vac-pack.",
    who: "Importer, Dubai",
    tag: "Direct Farm Sourcing",
  },
  {
    q:
      "What I appreciate is the honesty — if a lot isn't up to spec, they tell me before shipping. That's rare.",
    who: "Blender, Hamburg",
    tag: "Transparent Trading",
  },
  {
    q:
      "Small orders, treated like large ones. Documentation, packing, timing — all sorted, always.",
    who: "Retail Buyer, Singapore",
    tag: "Export-Ready",
  },
];

export const Testimonials = () => {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="relative bg-cream py-28 md:py-40 overflow-hidden"
    >
      {/* Giant quote mark */}
      <span
        aria-hidden
        className="pointer-events-none absolute -top-16 -left-8 md:left-4 font-serif text-gold/15 text-[22rem] md:text-[30rem] leading-none select-none"
      >
        “
      </span>

      <div className="relative mx-auto max-w-[1400px] px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 15 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="font-sans text-[11px] uppercase tracking-[0.32em] text-charcoal/60 mb-6 flex items-center gap-3"
        >
          <span className="text-gold">§</span> From the trade
        </motion.div>
        <motion.h2
          initial={{ opacity: 0, y: 25 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1, ease: [0.65, 0, 0.35, 1] }}
          className="font-serif font-light text-5xl md:text-6xl lg:text-7xl text-charcoal leading-[0.98] max-w-[18ch]"
        >
          Words from the <span className="italic text-forest">people</span>{" "}
          who receive our sacks.
        </motion.h2>

        <div className="grid md:grid-cols-3 gap-6 md:gap-8 mt-16 md:mt-24">
          {QUOTES.map((t, i) => (
            <motion.blockquote
              key={t.who}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{
                duration: 0.9,
                delay: i * 0.12,
                ease: [0.65, 0, 0.35, 1],
              }}
              className="relative flex flex-col border-t border-charcoal/15 pt-8"
              data-testid={`testimonial-${i}`}
            >
              <span className="font-serif italic text-gold text-sm mb-6">
                {t.tag}
              </span>
              <p className="font-serif text-2xl md:text-[1.7rem] leading-[1.28] text-charcoal">
                “{t.q}”
              </p>
              <footer className="mt-8 font-sans text-[11px] uppercase tracking-[0.28em] text-charcoal/60">
                — {t.who}
              </footer>
            </motion.blockquote>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
